import { render } from "./AssinaturaStatusDropdown.vue?vue&type=template&id=7dbec1fc"
import script from "./AssinaturaStatusDropdown.vue?vue&type=script&lang=js"
export * from "./AssinaturaStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__